import { createContext, useContext } from "react";
import useAppMotion from "../hooks/useAppMotion";

const AppMotionContext = createContext(null);

export function AppMotionProvider({ children }) {
  const value = useAppMotion();
  return (
    <AppMotionContext.Provider value={value}>{children}</AppMotionContext.Provider>
  );
}

export function useAppMotionContext() {
  const ctx = useContext(AppMotionContext);
  if (!ctx) {
    throw new Error("useAppMotionContext must be used within AppMotionProvider");
  }
  return ctx;
}
